import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Icon from '@/components/Icon'
import { Collapse } from 'reactstrap'
import ErrorBoundary from '@/components/ErrorBoundary'
import Resx from '@/components/Resx'

export class WhiteBox extends Component {
  static propTypes = {
    transparent: PropTypes.bool,
    clear: PropTypes.bool,
    className: PropTypes.string,
    header: PropTypes.any,
    headerClass: PropTypes.string,
    collapse: PropTypes.bool,
    collapsed: PropTypes.bool,
    buttons: PropTypes.node,
    children: PropTypes.node,
    dataCy: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.state = {
      isOpen: !(props.collapse && props.collapsed)
    }
  }

  toggle = (e) => {
    e.preventDefault()
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render () {
    const isTransparent = this.props.transparent || this.props.clear
    let classNames = isTransparent ? classnames('white-box white-box--trans', this.props.className) : classnames('white-box', this.props.className)
    classNames = this.state.isOpen ? classNames : classnames('white-box--close', classNames)

    const showHideIcon = this.state.isOpen ? 'chevron-up' : 'chevron-down'
    const dataCy = this.props.dataCy
      ? this.props.dataCy
      : typeof this.props.header === 'string'
        ? this.props.header
        : null

    return (
      <div className={classNames} data-cy={dataCy} >
        {this.props.header &&
        <div className={classnames('box__title', this.props.headerClass)}>
          {this.props.collapse &&
          <button onClick={this.toggle} className='white-box__show-hide'><Icon name={showHideIcon} /></button>} {/* end toggle button */}
          {typeof this.props.header === 'string' ? <Resx name={this.props.header} /> : this.props.header}

          {this.props.buttons &&
          <div className='box-t__right'>
            {this.props.buttons}
          </div>} {/* end button */}
        </div>} {/* end header */}
        <Collapse className='box__body' isOpen={this.state.isOpen}>
          <ErrorBoundary>
            {this.props.children}
          </ErrorBoundary>
        </Collapse>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.Box.js